module.exports = __webpack_public_path__ + "media/images/landing/persons/radek-finkous-5249e83a8362e265ba5fadc4d698bb82.jpeg";